import { isUndNullEmpNew } from '../../helpers/UtilsHelper';

export class UserLlmModelClass {
    constructor(
        id = '',
        code = '',
        enabled = false,
        priority = 0,
    ) {
        this.id = id;
        this.code = code;
        this.enabled = enabled;
        this.priority = priority;
    }

    static getClassName = () => {
        return 'UserLlmModelClass - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this?.getClassName() })?.result) {
            return new UserLlmModelClass(
                obj?.id,
                obj?.code,
                obj?.enabled,
                obj?.priority,
            )
        }
        return new UserLlmModelClass();
    }
}

export class UserLlmClass {
    constructor(
        id = '',
        enabled = false,
        priority = 0,
        models = [UserLlmModelClass?.getClass()],
        apiKey = '',
    ) {
        this.id = id;
        this.enabled = enabled;
        this.priority = priority;
        this.models = models;
        this.apiKey = apiKey;
    }

    static getClassName = () => {
        return 'UserLlmClass - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this?.getClassName() })?.result) {
            return new UserLlmClass(
                obj?.id,
                obj?.enabled,
                obj?.priority,
                obj?.models,
                obj?.apiKey,
            )
        }
        return new UserLlmClass();
    }
}

export class UserLlmModelSelectClass {
    constructor(
        id = '',
        userId = '',
        providers = [UserLlmClass?.getClass()],
        created = new Date()?.toISOString(),
    ) {
        this.id = id;
        this.userId = userId;
        this.providers = providers;
        this.created = created;
    }

    static getClassName = () => {
        return 'UserLlmModelSelectClass - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this?.getClassName() })?.result) {
            return new UserLlmModelSelectClass(
                obj?.id,
                obj?.userId,
                obj?.providers,
                obj?.created,
            )
        }
        return new UserLlmModelSelectClass();
    }
}